import { updateView } from '../../current-view/actions/updateView';
import { THREAD_VIEW } from 'conversations-visitor-experience-components/visitor-widget/constants/views';
import { getOriginViewContext } from '../../kb-article/kbArticleSelectors';
import { selectThread } from '../../selected-thread/actions/selectThread';
import { setStandardWidgetSize } from '../../widget-size/widgetSizeSlice';
// @ts-expect-error untyped module
import { getCurrentThreadId } from '../../thread-history/selectors/getCurrentThreadId';
export function restorePreviousViewFromKBArticle() {
  return (dispatch, getState) => {
    const {
      view: originView
    } = getOriginViewContext(getState());
    dispatch(setStandardWidgetSize());
    if (originView === THREAD_VIEW) {
      dispatch(selectThread(getCurrentThreadId(getState())));
    }
    dispatch(updateView(originView));
  };
}